"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITIONS = exports.ACTIONS = void 0;
const POSITIONS = exports.POSITIONS = {
  TOP_CENTER: 'topCenter',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_CENTER: 'bottomCenter'
};
const ACTIONS = exports.ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE'
};